import { useState } from "react";
import DialogModal from "src/components/Dialog";
import { ComputerIcon, PhoneIcon } from "src/components/Icons";
import useAppStore from "src/store/utils";
import Iframe from "../Iframe";
import styles from "../TemplateCard/templateCard.module.scss";

type OrientationType = "portrait" | "landscape";

interface TemplatePreviewProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const TemplatePreview = ({ show, setShow }: TemplatePreviewProps) => {
  const [orientation, setOrientation] = useState<OrientationType>("landscape");
  const { event } = useAppStore((state) => state);

  return (
    <DialogModal open={show} onOpenChange={setShow}>
      <div className={styles["templateCard__mobile-preview"]}>
        <div className={styles["templateCard__mobile-preview-title"]}>
          <h2>Preview</h2>

          <div className={styles["templateCard__mobile-views"]}>
            <div className={styles["templateCard__mobile-views-box"]}>
              <div
                className={`${orientation === "portrait" ? `border border-white` : ``} cursor-pointer rounded-md p-1`}
                onClick={() => setOrientation("portrait")}
              >
                <span className="text-white">
                  <PhoneIcon />
                </span>
              </div>
              <div
                className={`${orientation === "landscape" ? `border border-white` : ``} cursor-pointer rounded-md p-1`}
                onClick={() => setOrientation("landscape")}
              >
                <span className="text-white">
                  <ComputerIcon />
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <MobileIframe orientation={orientation} /> */}
        <div className="flex h-full w-full items-center justify-center">
          <Iframe
            orientation={orientation}
            src={`https://${event?.slug}.${process.env.REACT_APP_INAWO_WEDDING_SITE_END}/`}
          />
        </div>
      </div>
    </DialogModal>
  );
};

export default TemplatePreview;
